import { useState, useLayoutEffect } from "react";
import { hexToRgba } from "../utils/colorHelpers";

const COLOR_NAME = "--pl-colors-";
const FONT_NAME = "--pl-fonts-";
const useColors = () => {
  const [colorsApplied, setColorsApplied] = useState(false);

  useLayoutEffect(() => {
    if (document) {
      const theme = process.env?.REACT_APP_APP_THEME?.toString();
      const { style } = document.documentElement;
      if (theme === "ST") {
        document.body.style.background = "#313E5A";
        style.setProperty(`${COLOR_NAME}gradientStart`, `#1EE6A0`);
        style.setProperty(`${COLOR_NAME}gradientEnd`, `#1EE6A0`);

        style.setProperty(`${COLOR_NAME}primary`, `#1EE6A0`);
        style.setProperty(`${COLOR_NAME}primary-10`, hexToRgba(`#1EE6A0`, 0.1));
        style.setProperty(`${COLOR_NAME}primary-20`, hexToRgba(`#1EE6A0`, 0.2));
        style.setProperty(`${COLOR_NAME}primary-60`, hexToRgba(`#1EE6A0`, 0.6));
        style.setProperty(`${COLOR_NAME}primary-80`, hexToRgba(`#1EE6A0`, 0.8));

        style.setProperty(`${COLOR_NAME}danger`, `#FF4867`);
        style.setProperty(`${COLOR_NAME}danger-10`, hexToRgba(`#FF4867`, 0.1));

        style.setProperty(`${COLOR_NAME}success`, `#1EE6A0`);
        style.setProperty(`${COLOR_NAME}success-10`, hexToRgba(`#1EE6A0`, 0.1));

        style.setProperty(`${COLOR_NAME}complementary`, `#A160FB`);
        style.setProperty(`${COLOR_NAME}complementary-10`, hexToRgba(`#A160FB`, 0.1));

        style.setProperty(`${COLOR_NAME}warning`, `#F6BF6D`);
        style.setProperty(`${COLOR_NAME}warning-10`, hexToRgba(`#F6BF6D`, 0.1));

        style.setProperty(`${FONT_NAME}light`, "proxima-light");
        style.setProperty(`${FONT_NAME}regular`, "proxima-regular");
        style.setProperty(`${FONT_NAME}bold`, "proxima-bold");
        style.setProperty(`${FONT_NAME}black`, "proxima-black");
      }
    }
    setColorsApplied(true);
  }, []);

  return colorsApplied;
};

export default useColors;
